/**
 * Shared query key and select definitions used by both
 * React hooks (client) and the prerender script (build).
 * 
 * Keeping these in sync prevents cache misses during SSR hydration.
 */

import type { FilterParams } from "@/types/filters";

export const RESTAURANT_SELECT = `
  *,
  neighborhood:neighborhoods(
    id,
    name,
    city:cities(
      name,
      state
    )
  ),
  eventspaces (
    id,
    restaurant_id,
    space_name,
    capacity,
    event_types,
    description,
    photos,
    amenities:eventspace_amenities(
      amenity:amenities(*)
    ),
    pricing_tiers(*)
  )
`;

export const NEIGHBORHOOD_SELECT = `
  id,
  name,
  city_id,
  city:cities(name, state)
`;

export const queryKeys = {
  featuredRestaurants: ['featuredRestaurants'] as const,
  restaurants: (filters: FilterParams) => ['restaurants', filters] as const,
  neighborhoods: ['neighborhoods'] as const,
};

export const DEFAULT_FILTERS: FilterParams = {
  neighborhood: '',
  eventType: '',
  groupSize: '',
  priceRange: '',
  search: '',
};

/** staleTime for prerendered queries — avoids refetch flash during hydration */
export const SSR_STALE_TIME = 60_000; // 1 minute
